import Tutorial from './Tutorial';
import common from '../../common';
import {translate} from '../../utils';

export default class TutorialLevel6 extends Tutorial {
	constructor(finger, panel, scene, commands) {
		super(finger, panel, scene, commands);
	}

	update() {
		super.update();
	}

	play() {
		super.play();

		if (this._destroyed) {
			return;
		}

		this.tweens.removeAll();

		let lastTween = null;

		this._scene.runButton.position.y = common.STAGE_HEIGHT - 260;

		if (this.stage === 0) {
			this._finger.alpha = 1;
			this._finger.scale.set(1, 1);
			this._finger.rotation = 0;
			this._finger.position.set((common.STAGE_WIDTH * 0.5) + 80, 125);
			this._commands.ui.interactive = true;
			this._commands.ui.interactiveChildren = true;
			this._commands.ui.add.interactive = true;
			common.focusOverlay.focusSprite(this._commands.ui.add, true);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE6.OPEN_TOOLS');
			this.signals.update.dispatch();

			new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 250)
				.easing(P3.utils.Easing.Back2.Out)
				.repeat(1)
				.yoyo(true)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -5 * PIXI.DEG_TO_RAD
				}, 250)
				.easing(P3.utils.Easing.Back2.Out)
				.repeat(1)
				.yoyo(true)
				.start();
		} else if (this.stage === 1) {
			const focusWidth = common.STAGE_WIDTH * 0.5 - (common.STAGE_WIDTH - P3.View.width) * 0.5 + 240;

			common.focusOverlay.setFocus(20, 10, focusWidth, 385);
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set((common.STAGE_WIDTH * 0.5) + 80, 280);
			this._commands.ui.interactive = true;
			this._commands.ui.interactiveChildren = true;
			this._commands.ui.add.interactive = false;
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE6.DRAG_TRANSFORM');
			this.signals.update.dispatch();

			this._commands.toolboxItems[0].ui.interactive = false;
			this._commands.toolboxItems[1].ui.interactive = false;

			const t1 = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					x : (common.STAGE_WIDTH - P3.View.width) * 0.5 + 200,
					y : [300, 150]
				}, 750)
				.easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
				.interpolation(P3.utils.TWEEN.Interpolation.Bezier)
				.delay(500)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					alpha: 0
				}, 500)
				.easing(P3.utils.TWEEN.Easing.Linear.None);

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 2) {
			common.focusOverlay.setFocus(20, 50, 430, 140);

			this._finger.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 450, 155);
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.rotation = 0;

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE6.SELECT_CANNONBOLT');
			this.signals.update.dispatch();

			this._commands.ui.interactive = true;
			this._commands.ui.interactiveChildren = true;
			this._commands.ui.add.interactive = false;
			this._commands.commands[1].locked = true;
			this._commands.commands[1].ui.interactive = false;

			if (this._commands.selector) {
				this._commands.selector.children[0].interactive = false;
				this._commands.selector.children[1].interactive = false;
			}

			new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 250)
				.easing(P3.utils.Easing.Back2.Out)
				.repeat(1)
				.yoyo(true)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -5 * PIXI.DEG_TO_RAD
				}, 250)
				.easing(P3.utils.Easing.Back2.Out)
				.repeat(1)
				.yoyo(true)
				.start();
		} else if (this.stage === 3) {
			this._finger.rotation = 0;
			this._finger.scale.set(1);
			this._finger.alpha = 1;
			this._finger.visible = false;
			this._commands.ui.interactive = true;
			this._commands.ui.interactiveChildren = true;
			this._commands.ui.add.interactive = true;
			this._commands.toolboxItems[0].ui.interactive = true;
			this._commands.toolboxItems[1].ui.interactive = true;
			common.focusOverlay.visible = false;

			this._commands.commands[1].canChangeVariable = false;

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE6.FINISH');
			this.signals.update.dispatch();
		}

		if (lastTween) {
			lastTween.onComplete(() => {
				P3.utils.delayg(this.tweens, 1, () => {
					this.play();
				});
			});
		}
	}

	stop() {
		super.stop();
	}

	prepareCommands() {
		super.prepareCommands();
	}
}
